const config = {
  development: {
    apiBaseUrl: "http://localhost:5141/api/advanced/",
    apiBaseUrl2: `http://localhost:5141/api`,
    adminApi: 'http://localhost:5141/admin/api',
    appName: "OrisBetBonus",
    imgUrl: "https://dev-test.hookapps.xyz",
  },
  developmentProduction: {
    apiBaseUrl: "http://api.atlantisbonus.xyz/api/advanced/",
    apiBaseUrl2: `http://api.atlantisbonus.xyz/api`,
    adminApi: 'http://api.atlantisbonus.xyz/admin/api',
    appName: "OrisBetBonus",
    imgUrl: "https://dev-test.hookapps.xyz",
  },
  production: {
    apiBaseUrl: typeof window !== 'undefined' ? `https://api.${window.location.hostname}/api/advanced/` : '',
    apiBaseUrl2: typeof window !== 'undefined' ? `https://api.${window.location.hostname}/api` : '',
    adminApi: typeof window !== 'undefined' ? `https://api.${window.location.hostname}/admin/api` : '',
    appName: "HookBonus",
    imgUrl: "",
  },
};

const env = "production";
export default config[env];
